import React, { useState, useEffect } from "react";
import config from "../../../config/domain";
import { NavLink, Link } from "react-router-dom";
import { RoutesUrl } from "../../Routes/constents";
import { getTolocalStorage } from "../../Constants/commenFeatures";
import LoginService from "../../../services/login/loginService";

const HeaderAuth = ({ logout, isNavbar, showNavbar }) => {
  const [isVendor, setIsVendor] = useState();
  const [etotpEnabled, setEtotpEnabled] = useState(false);
  const [openMenu, setOpenMenu] = useState("");

  useEffect(() => {
    async function checkVandorAuth() {
      const isVAndor = await getTolocalStorage("loginAs");

      if (isVAndor === "vendor") {
        setIsVendor(true);
      } else {
        setIsVendor(false);
      }

      const etotpFlow = LoginService.getAccData("accs")?.etotpSwitch;
      setEtotpEnabled(etotpFlow);
    }

    checkVandorAuth();
  }, []);

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? "" : menuName);
  };

  const closeMenu = () => {
    setOpenMenu("");
  };

  const handleTabCycle = (e) => {
    if (e.key !== "Tab" || !isNavbar) return;

    const closeButton = document.querySelector(".nav-toggle-btn");
    const menuElements = Array.from(document.querySelectorAll(
      ".mobileView a, .mobileView button, .mobileView input, .mobileView [tabindex='0']"
    ));

    const allFocusable = closeButton ? [closeButton, ...menuElements] : menuElements;

    if (!allFocusable.length) return;

    const firstItem = allFocusable[0];
    const lastItem = allFocusable[allFocusable.length - 1];

    if (e.shiftKey && document.activeElement === firstItem) {
      e.preventDefault();
      lastItem.focus();
    } else if (!e.shiftKey && document.activeElement === lastItem) {
      e.preventDefault();
      firstItem.focus();
    }
  };

  return (
    <div className="navbar-menu">
      {/* Mobile View */}
      <div
        className={isNavbar ? "mobileView" : "hide_nav"}
        onKeyDown={handleTabCycle}
      >
        <div>
          <ul onClick={showNavbar}>
            {isVendor ? (
              <>
                <li>
                  <NavLink
                    exact
                    activeClassName="active"
                    to={RoutesUrl.VendorDashboard}
                  >
                    Dashboard
                  </NavLink>
                </li>

                <li className="active">
                  <NavLink
                    exact
                    activeClassName="active"
                    to={RoutesUrl.VendorMyApps}
                  >
                    My Apps
                  </NavLink>
                </li>
              </>
            ) : (
              <li className="active">
                <NavLink exact activeClassName="active" to={RoutesUrl.MyApps}>
                  My Apps
                </NavLink>
              </li>
            )}

            {etotpEnabled && (
              <li>
                <NavLink exact activeClassName="active" to={RoutesUrl.Etotp}>
                  TOTP
                </NavLink>
              </li>
            )}

            <li
              className={`nav-sub-container ${
                openMenu === "documentation" ? "open" : ""
              }`}
              onMouseEnter={() => setOpenMenu("documentation")}
              onMouseLeave={closeMenu}
            >
              <a
                href="javascript:void(0)"
                onClick={(e) => {
                  e.preventDefault();
                  toggleMenu("documentation");
                }}
                onFocus={() => setOpenMenu("documentation")}
              >
                Documentation
              </a>

              <ul className="nav-sublink">
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={config.jmw_client_docs}
                  >
                    Client Documentation
                  </a>
                </li>

                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={config.jmw_partner_docs}
                  >
                    Partner Documentation
                  </a>
                </li>
              </ul>
            </li>

            <li>
              <NavLink exact activeClassName="active" to={RoutesUrl.Resouces}>
                Resources
              </NavLink>
            </li>

            <li>
              <NavLink exact activeClassName="active" to={RoutesUrl.Support}>
                Support
              </NavLink>
            </li>

            <li onClick={logout}>
              <NavLink to="#">
                <i className="edel-icon-logout"></i> Logout
              </NavLink>
            </li>
          </ul>
        </div>
      </div>

      {/* Desktop View */}
      <ul className="destopView">
        {isVendor ? (
          <>
            <li>
              <NavLink
                exact
                activeClassName="active"
                to={RoutesUrl.VendorDashboard}
              >
                Dashboard
              </NavLink>
            </li>

            <li className="active">
              <NavLink
                exact
                activeClassName="active"
                to={RoutesUrl.VendorMyApps}
              >
                My Apps
              </NavLink>
            </li>
          </>
        ) : (
          <li className="active">
            <NavLink exact activeClassName="active" to={RoutesUrl.MyApps}>
              My Apps
            </NavLink>
          </li>
        )}

        {etotpEnabled && (
          <li>
            <NavLink exact activeClassName="active" to={RoutesUrl.Etotp}>
              TOTP
            </NavLink>
          </li>
        )}

        <li
          className={`nav-sub-container ${
            openMenu === "documentation" ? "open" : ""
          }`}
          onMouseEnter={() => setOpenMenu("documentation")}
          onMouseLeave={closeMenu}
        >
          <a
            href="javascript:void(0)"
            onClick={(e) => {
              e.preventDefault();
              toggleMenu("documentation");
            }}
            onFocus={() => setOpenMenu("documentation")}
          >
            Documentation
          </a>

          <ul className="nav-sublink">
            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href={config.jmw_client_docs}
              >
                Client Documentation
              </a>
            </li>

            <li>
              <a
                target="_blank"
                rel="noreferrer"
                href={config.jmw_partner_docs}
              >
                Partner Documentation
              </a>
            </li>
          </ul>
        </li>

        <li>
          <NavLink exact activeClassName="active" to={RoutesUrl.Resouces}>
            Resources
          </NavLink>
        </li>

        <li>
          <NavLink exact activeClassName="active" to={RoutesUrl.Support}>
            Support
          </NavLink>
        </li>

        <li onClick={logout}>
          <Link to="#">
            <i className="edel-icon-logout"></i>
            Logout
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default HeaderAuth;